import React from 'react';
import { Magnet, ShieldCheck, Repeat } from 'lucide-react';
export function SistemaACESection() {
  const phases = [{
    number: '01',
    icon: <Magnet className="w-6 h-6 text-emerald" data-id="element-178" />,
    title: 'ATRACCIÓN DE CONTRATOS PREMIUM',
    description: 'Segmentamos propietarios de propiedades de alto valor, administradores de Airbnb, dueños de oficinas y restaurantes que necesitan limpieza profesional y recurrente en tu zona.'
  }, {
    number: '02',
    icon: <ShieldCheck className="w-6 h-6 text-emerald" data-id="element-179" />,
    title: 'POSICIONAMIENTO DE AUTORIDAD',
    description: 'Construimos tu marca de limpieza premium con contenido visual de antes/después, reseñas masivas en Google y un perfil que comunica confianza y profesionalismo absoluto.'
  }, {
    number: '03',
    icon: <Repeat className="w-6 h-6 text-emerald" data-id="element-180" />,
    title: 'SISTEMA DE CONTRATOS RECURRENTES',
    description: 'Diseñamos paquetes de mantenimiento mensual con cobro automático recurrente. El cliente firma una vez y paga todos los meses sin que nadie tenga que cobrar manualmente.'
  }];
  return <section id="sistema-ace" className="py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-181">
      <div className="text-center mb-20" data-id="element-182">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-183">
          LA CURA — <span className="text-gold" data-id="element-184">SISTEMA A.C.E.™ CLEANING</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-185">
          El método exacto para dejar de competir por precio y empezar a cerrar
          contratos comerciales de alto valor.
        </p>
      </div>

      <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-carbon-lighter before:to-transparent" data-id="element-186">
        {phases.map((phase, index) => <div key={index} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-187">
            {/* Timeline Icon/Number */}
            <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-carbon bg-carbon-light text-emerald font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_0_2px_rgba(5,150,105,0.2)] z-10" data-id="element-188">
              {phase.icon}
            </div>

            {/* Content Card */}
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 md:p-8 rounded-lg bg-carbon-light border border-carbon-lighter hover:border-emerald/30 transition-colors" data-id="element-189">
              <div className="flex items-center gap-4 mb-4" data-id="element-190">
                <span className="text-4xl font-black text-carbon-lighter select-none" data-id="element-191">
                  {phase.number}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-192">
                  {phase.title}
                </h3>
              </div>
              <p className="text-gray-400 leading-relaxed" data-id="element-193">
                {phase.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}